import React, { useState } from 'react';
import './Sidebar.css';
import SidebarRow from './SidebarRow.js';
import EmojiFlagsIcon from '@material-ui/icons/EmojiFlags';
import PeopleIcon from '@material-ui/icons/People';
import ChatIcon from '@material-ui/icons/Chat';
import StorefrontIcon from '@material-ui/icons/Storefront';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import { useStateValue } from "./StateProvider";
import MenuIcon from '@material-ui/icons/Menu';

function Sidebar() {
    const [{ user }, dispatch] = useStateValue(); 
    const [nav, setNav] = useState(false);
    const showNav = () => setNav(!nav);
    return (
        <div className="sidebar">
            <div className={nav? 'navfirst':'first'}>
                <SidebarRow src={user.photoURL} title={user.displayName} />
                <SidebarRow Icon = {LocalHospitalIcon} title = "COVID-19 Information Center" className="covid"/>
                <SidebarRow Icon= {EmojiFlagsIcon} title='Pages' className="page"/>
                <SidebarRow Icon = {PeopleIcon} title='Friends' className="friend"/>
                <SidebarRow Icon = {ChatIcon} title = 'Messenger' className="messenger" />
                <SidebarRow Icon = {StorefrontIcon} title = 'Marketplace' className="market" />
                <SidebarRow Icon = {VideoLibraryIcon} title = "Videos" className="video" />
                <SidebarRow Icon = {ExpandMoreOutlinedIcon} title = "Marketplace" />
            </div>
            <div className="second">
                <MenuIcon FontSize="large" className="nav" onClick={showNav} />
            </div>
        </div>
    )
}

export default Sidebar

